import React from 'react';
//a
export default function Card({ title, children, preDataSet, dataSet = [], extra, footer }) {
  return (
    <div className="card">
      <div className="card__title">
        <span className="card__left">{title}</span>
        <If condition={extra}>{extra}</If>
      </div>
      <div className="card__slot-wrapper">
        <If condition={preDataSet}>
          <div
            className="card-grid-wrapper"
            style={{
              borderBottom: '1px solid rgba(0, 0, 0, 0.09)',
              paddingBottom: '20px',
              marginBottom: '16px',
            }}
          >
            <For of={preDataSet} each="item" index="index">
              <div className="item-wrapper">
                <div className="label">{item.label}: </div>
                <div className="value" style={{ maxWidth: 383 }}>
                  {item?.value ?? '-'}
                </div>
              </div>
            </For>
          </div>
        </If>
        <Choose>
          <When condition={dataSet.length > 0}>
            <div className="card-grid-wrapper">
              <For of={dataSet} each="item" index="index">
                <div className="item-wrapper">
                  <div className="label">{item.label}: </div>
                  <div className="value" style={{ maxWidth: 383 }}>
                    {item?.value ?? '-'}
                  </div>
                </div>
              </For>
            </div>
            <If condition={footer}>{footer}</If>
          </When>
          <Otherwise>{children}</Otherwise>
        </Choose>
      </div>
    </div>
  );
}
